import React from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import Crud from "../Crud";

function fractionToDecimal(fraction) {
  const [numerator, denominator] = String(fraction ?? "").split("/").map(Number);
  if (!denominator || Number.isNaN(numerator) || Number.isNaN(denominator)) {
    throw new Error(
      `Invalid Fractional value "${fraction}". Please enter it in the format X/Y (e.g. 5/1).`
    );
  }
  return numerator / denominator;
}

/**
 * TABLE SYSTEMODDSCONVERSION
 */
function OddsConversion() {
  return (
    <Crud
      title="Odds Conversion"
      getUrl={() => "/Game/OddsConversion_GetList"}
      // INSERT
      insertUrl={() => "/Game/OddsConversion_Insert"}
      insertValidate={(data, { fractionalFormat }, error) => {
        try {
          fractionToDecimal(fractionalFormat);
          return error();
        } catch (e) {
          alert(e.message);
          return error(e.message);
        }
      }}
      insertParams={(
        { userId },
        {
          americanFormat,
          fractionalFormat,
          fractionalValue,
          decimal_2,
          decimal_3,
          malay,
          indo,
          hongKong,
        }
      ) => {
        let decimalFormat;
        try {
          decimalFormat = fractionToDecimal(fractionalFormat);
        } catch (e) {
          alert(e.message);
          throw e;
        }
        return {
          AmericanFormat: americanFormat,
          DecimalFormat: decimalFormat,
          FractionalFormat: fractionalFormat,
          FractionalValue: Number(fractionalValue),
          Decimal_2: Number(decimal_2),
          Decimal_3: Number(decimal_3),
          Malay: Number(malay),
          Indo: Number(indo),
          HongKong: Number(hongKong),
          IdUser: Number(userId),
        };
      }}
      // UPDATE
      updateUrl={() => "/Game/OddsConversion_Update"}
      updateParams={(
        { userId },
        {
          americanFormat,
          fractionalFormat,
          fractionalValue,
          decimal_2,
          decimal_3,
          malay,
          indo,
          hongKong,
        }
      ) => {
        let decimalFormat;
        try {
          decimalFormat = fractionToDecimal(fractionalFormat);
        } catch (e) {
          alert(e.message);
          throw e;
        }
        return {
          AmericanFormat: americanFormat,
          DecimalFormat: decimalFormat,
          FractionalFormat: fractionalFormat,
          FractionalValue: Number(fractionalValue),
          Decimal_2: Number(decimal_2),
          Decimal_3: Number(decimal_3),
          Malay: Number(malay),
          Indo: Number(indo),
          HongKong: Number(hongKong),
          IdUser: Number(userId),
        };
      }}
      // DELETE
      deleteUrl={() => "/Game/OddsConversion_Delete"}
      deleteParams={({ userId }, _, { americanFormat }) => ({
        AmericanFormat: americanFormat,
        IdUser: Number(userId),
      })}
    >
      <TableHeaderColumn dataField="americanFormat" isKey>
        American Odds
      </TableHeaderColumn>
      <TableHeaderColumn dataField="fractionalFormat">
        Fractional
      </TableHeaderColumn>
      <TableHeaderColumn dataField="fractionalValue">
        Fractional Value
      </TableHeaderColumn>
      <TableHeaderColumn dataField="decimal_2">
        Decimal (2-digits)
      </TableHeaderColumn>
      <TableHeaderColumn dataField="decimal_3">
        Decimal (3-digits)
      </TableHeaderColumn>
      <TableHeaderColumn dataField="malay">Malaysian</TableHeaderColumn>
      <TableHeaderColumn dataField="indo">Indonesian</TableHeaderColumn>
      <TableHeaderColumn dataField="hongKong">Hong Kong</TableHeaderColumn>
    </Crud>
  );
}

export default OddsConversion;
